import { useMemo } from 'react';
import { CookieUtils } from '@framework/CookieUtils';
import { SignUpModeCookieName, getAdjustedSignUpMode } from '@framework/auth/signUpMode';
import type { SignUpMode } from '@framework/auth/signUpMode';

const CookieAttributes = { expires: 10 * 60, path: '/' };

export const useStoreSignUpMode = () => {
  return useMemo(() => {
    const store = (mode: SignUpMode) => {
      CookieUtils.set(SignUpModeCookieName, mode, CookieAttributes);
    };

    const fetch = (): SignUpMode => {
      return getAdjustedSignUpMode(CookieUtils.get(SignUpModeCookieName) ?? null);
    };

    return { store, fetch };
  }, []);
};
